<template>
    <blogs-carousel-section
        v-if="attributes.asyncData.posts.length"
        class="recent-blog-posts-section-module"
        :slides="attributes.asyncData.posts"
        :title="$snippet('recent_blog_posts_title', 'our most recent blog posts')"
        :button-link="$snippet('recent_blog_posts_button_link', '/blog')"
        :button-text="$snippet('recent_blog_posts_button_text', 'all blog posts')"
    />
</template>

<script>
    import BlogsCarouselSection from '../../../organisms/BlogsCarouselSection/BlogsCarouselSection';

    export default {
        name: 'recent-blog-posts-section-module',

        components: { BlogsCarouselSection },

        props: {
            attributes: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },

        async asyncData({ store, attributes }) {
            const locale = store.state.locales.locales.find(({ code }) => code === store.state.locales.locale ?? 'en')?.code;

            const { posts } = await store.dispatch('blogs/fetchRecentBlogPosts', {
                exclude: attributes.__page.id,
                locale,
            });

            return {
                posts,
            };
        },
    };
</script>
